import React from 'react';

type Props = {
  canExport: boolean;
  exportMode: boolean;
  selectedCount: number;
  merging: boolean;
  pngExporting: boolean;
  onEnterExport: () => void;
  onMergeClick: () => void;
  onExportPng: () => void;
  onCancel: () => void;
};

const LibraryHeader: React.FC<Props> = ({
  canExport, exportMode, selectedCount, merging, pngExporting,
  onEnterExport, onMergeClick, onExportPng, onCancel
}) => {
  if (!canExport) return null;

  return (
    <>
      <div className="library-header" style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'flex-start', width:'100%' }}>
        <div className="actions library-actions">
          {!exportMode && (
            <button className="tool-button" onClick={onEnterExport} title="Select multiple sprites to MERGE or export PNG">
              EXPORT
            </button>
          )}
          {exportMode && (
            <>
              <button
                className="tool-button"
                onClick={onMergeClick}
                disabled={merging || selectedCount===0}
                title="Merge selected into an existing .p8 file"
              >
                {merging ? 'MERGING…' : 'MERGE'}
              </button>
              <button
                className="tool-button"
                onClick={onExportPng}
                disabled={pngExporting || selectedCount===0}
                title="Export selected to a 128×128 PNG for PICO‑8 (IMPORT compatible)"
              >
                {pngExporting ? 'PNG…' : 'PNG'}
              </button>
              <button className="tool-button" onClick={onCancel}>CANCEL</button>
            </>
          )}
        </div>
      </div>

{exportMode && (
        <>
          <div className="selection-hint" aria-live="polite" style={{ margin: '8px 0 4px', opacity: 0.85 }}>
            {selectedCount} selected sprites for export or merge.
          </div>
          {/* NEW: Kort förklaring om secondary palette vid export/merge */}
            <div className="export-note" style={{ fontSize: 12, opacity: 0.9, margin: '0 0 12px' }}>
            Note: Use pal() to show secondary colors. MERGE injects a
            pal() block for you.
            </div>
        </>
      )}
    </>
  );
};

export default LibraryHeader;